module.exports = __webpack_public_path__ + "static/finelite_body_img2-4769ed5cabd44e49ca2de34b0b4531e7.jpg";